import React from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import useSearchParams from '../../../../useSearchParams';

const DepartmentPosition = () => {
  const {query, setQuery} = useSearchParams();

  const currentDepartments = query?.departments || [];
  const currentPositions = query?.positions || [];

  const removeDepartment = (departmentToRemove: string) => {
    const newDepartments = currentDepartments.filter(
      (dept: string) => dept !== departmentToRemove
    );
    setQuery({
      departments: newDepartments.length > 0 ? newDepartments : null,
      page: 1,
    });
  };

  const removePosition = (positionToRemove: string) => {
    const newPositions = currentPositions.filter(
      (pos: string) => pos !== positionToRemove
    );
    setQuery({
      positions: newPositions.length > 0 ? newPositions : null,
      page: 1,
    });
  };

  const clearAll = () => {
    setQuery({
      departments: null,
      positions: null,
      page: 1,
    });
  };

  // 部署または役職のフィルタが設定されているかチェック
  const hasFilters = (currentDepartments.length > 0) || (currentPositions.length > 0);

  if (!hasFilters) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      {/* 部署が設定されている場合 */}
      {currentDepartments.length > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">部署:</span>
          <div className="flex items-center gap-2 flex-wrap">
            {currentDepartments.map((department: string) => (
              <span
                key={`dept-${department}`}
                className="bg-c-bg h-6 rounded text-sm px-3 flex items-center gap-1"
              >
                {department}
                <button
                  onClick={() => removeDepartment(department)}
                  className="flex items-center justify-center cursor-pointer hover:bg-gray-200 rounded-full p-0.5"
                >
                  <XMarkIcon className="h-3 w-3" />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}

      {/* 役職が設定されている場合 */}
      {currentPositions.length > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">役職:</span>
          <div className="flex items-center gap-2 flex-wrap">
            {currentPositions.map((position: string) => (
              <span
                key={`pos-${position}`}
                className="bg-c-bg h-6 rounded text-sm px-3 flex items-center gap-1"
              >
                {position}
                <button
                  onClick={() => removePosition(position)}
                  className="flex items-center justify-center cursor-pointer hover:bg-gray-200 rounded-full p-0.5"
                >
                  <XMarkIcon className="h-3 w-3" />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default DepartmentPosition;